module.exports = __webpack_public_path__ + "img/ico-produto-w.2d0b2e5a.png";